
<script setup>

const { references } = defineProps( [ 'references' ] )

</script>

<template>

  <div>

    <div class="text-[#666] space-y-6">

      <p>

        The data presented in this tool is for informational and educational purposes only.
        
        It reflects pathogen trends observed across the United States, and may not indicate potential outbreaks or emerging regional trends. 
        
        Always refer to relevant guidelines to determine appropriate testing.
      
      </p>
      
      <p>

        The data presented in this tool is updated on an annual basis (subject to change).
        
        Each individual pathogen notes the specific date that the data was pulled and how often the source publishes said data.
        
        Please consult the original source for the most current data.

        National averages are not part of the original source data.

      </p>

      <div v-if="references.length > 0" class="space-y-4">

        <h2>References</h2>

        <ul v-for="reference in references">

          <li class="flex gap-2">

            <span class="min-w-6 text-end">{{ reference.id }}.</span>

            <div class="">

              <p>{{ reference.text }}</p>

              <a v-if="reference.url" class="block break-all hover:underline" :href="reference.url" target="_blank">{{ reference.url }}</a>

            </div>

          </li>

        </ul>

      </div>
      
    </div>

  </div>

</template>